// @ts-nocheck

import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { messageAction } from '../../../actions/app.action'
import {
  fetchPublicRatingReviewStatus,
  getCoursesRatingListCall,
  publicRateReviewCall,
} from '../../../actions/reviewratings.action'
import CourseCompleted from '../../../components/sis/student/emailReveiw/CourseCompleted'
import { MESSAGE_SEVERITIES } from '../../../helpers/constants'
import { get, isEmpty, noop } from '../../../helpers/utils'
import { mapGeneralErrors } from '../../../helpers/validator'
import withRouteContext from '../../../hocs/RouterContextHOC'
import withStudentDetails from '../../../hocs/withStudentDetailHOC'

function courseCompletedContainer({
  getCoursesRatingListCall,
  fetchPublicRatingReviewStatus,
  publicRateReviewCall,
}) {
  const { t } = useTranslation()
  const [openReviewPopup, setOpenReviewPopup] = React.useState(false)
  const [coursesCompletedList, setCoursesCompletedList] = React.useState([])
  const [courseReviewSetting, setCourseReviewSetting] = React.useState([])
  const [enrollmentDetails, setEnrollmentDetails] = React.useState({})

  const toggleReviewPopup = (e, row) => {
    if (!openReviewPopup) {
      setEnrollmentDetails(row)
      checkRatingReviewStatusAndReviewSettings([row.cgi_id])
    } else {
      setEnrollmentDetails([])
    }
    setOpenReviewPopup(!openReviewPopup)
  }

  const getCoursesRating = () => {
    const currentUrl = window.location.pathname
    const id = currentUrl.match(/\/coursereviews\/([^/]+)/)?.[1]

    if (id) {
      getCoursesRatingListCall(
        id,
        (data) => {
          setCoursesCompletedList(data)
        },
        noop
      )
    }
  }

  useEffect(() => {
    getCoursesRating()
  }, [])

  const checkRatingReviewStatusAndReviewSettings = (cgi_id) => {
    const queryParams = cgi_id.map((id) => `cgi_id[]=${id}`).join('&')
    fetchPublicRatingReviewStatus(
      queryParams,
      (data) => {
        setCourseReviewSetting(data)
      },
      noop
    )
  }

  const rateReviewCourse = (values) => {
    const payload = {
      pgm_id: enrollmentDetails.enr_program_id,
      enr_id: enrollmentDetails.enr_id,
      rating: values.rating,
      contextType: 'program_course',
      review: values.review,
      urn: coursesCompletedList.urn,
      course_id: enrollmentDetails.cr_id,
      enc_id: enrollmentDetails.enc_id,
      cgi_id: enrollmentDetails.cgi_id,
      sch_id: enrollmentDetails?.sch_id,
      program_name: enrollmentDetails?.pgm_name,
    }
    publicRateReviewCall(
      payload,
      () => {
        toggleReviewPopup()
        messageAction({
          subTitle: 'message:rateReviewProgramSuccess',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
        getCoursesRating()
      },
      (err) => {
        const error = get(err, 'response.data.code', '')
        if (!isEmpty(error)) {
          messageAction({
            subTitle: mapGeneralErrors(error, 'error:errorRateReviewProgram'),
            severity: MESSAGE_SEVERITIES.ERROR,
          })
        } else {
          messageAction({
            subTitle: 'error:errorRateReviewProgram',
            severity: MESSAGE_SEVERITIES.ERROR,
          })
        }
      }
    )
  }

  const allHeadCells = [
    {
      id: 'course_name',
      label: t('courseName'),
      isSort: false,
      sortProperty: 'course_name',
    },
    {
      id: 'course_date',
      label: t('dateAndTimeOfCompletion'),
      isSort: false,
      sortProperty: 'course_date',
    },
    {
      id: 'actions',
      label: t('actions'),
      isSort: false,
      sortProperty: 'actions',
    },
  ]
  return (
    <CourseCompleted
      allHeadCells={allHeadCells}
      toggleReviewPopup={toggleReviewPopup}
      openReviewPopup={openReviewPopup}
      coursesCompletedList={coursesCompletedList}
      rateReviewCourse={rateReviewCourse}
      courseReviewSetting={courseReviewSetting}
    />
  )
}

courseCompletedContainer.propTypes = {
  getCoursesRatingListCall: PropTypes.func,
  fetchPublicRatingReviewStatus: PropTypes.func,
  publicRateReviewCall: PropTypes.func,
}

courseCompletedContainer.defaultProps = {
  getCoursesRatingListCall: noop,
  fetchPublicRatingReviewStatus: noop,
  publicRateReviewCall: noop,
}
const mapStateToProps = () => ({})

/**
 *  @exports connect function of redux
 */
export default withStudentDetails(
  withRouteContext(
    connect(mapStateToProps, {
      getCoursesRatingListCall,
      fetchPublicRatingReviewStatus,
      publicRateReviewCall,
    })(courseCompletedContainer)
  )
)
